import showError from '@/handler/error';
import { apiConfig } from '../api-config';

export const insertReadNotification = async (idUser: string, cdTerritory: string, tokenKey: string, isRead: boolean, tag: string, ticketId: string) => {
  const uri = `api/GenericRead/create-read?idUser=${idUser}&isRead=${isRead}&tokenKey=${tokenKey}&cdTerritory=${cdTerritory}&tag=${tag}&ticketId=${ticketId}`;
  return apiConfig
    .post(`${uri}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(({ data }) => data)
    .catch(showError);
};
